'use client';

import ErrorBody from '@components/404Body';
import { useEffect } from 'react';
import Sentry from '@sentry/nextjs';

const body = [
  {
    image: {
      id: 'ae54d47d-eab5-48e4-a80b-f7d0d5c79097',
      name: 'traeger404-pro-tip-pig5',
      endpoint: 'traeger',
      defaultHost: 'cdn.media.amplience.net',
      mimeType: 'image/png',
    },
    links: [
      {
        asButton: false,
        isAnchorLink: false,
        isExternal: true,
        noFollow: false,
        noIndex: false,
        displayName: 'Home',
        externalLink: '/',
      },
      {
        asButton: false,
        isAnchorLink: false,
        isExternal: false,
        noFollow: false,
        noIndex: false,
        displayName: 'Explore Grills',
        link: 'shop/wood-pellet-grills',
      },
      {
        asButton: false,
        isAnchorLink: false,
        isExternal: false,
        noFollow: false,
        noIndex: false,
        displayName: 'Check out our Recipes',
        link: 'recipes',
      },
      {
        asButton: false,
        isAnchorLink: false,
        isExternal: true,
        noFollow: false,
        noIndex: false,
        displayName: 'Get Support',
        externalLink: 'https://support.traeger.com/hc/en-us',
      },
    ],
    title: 'Oops! Looks like this page got lost in the smoke.',
    description:
      "We couldn't find the page you were looking for, but don't worry — we can help you get back on track!  If you're looking for the perfect grill, delicious recipes, or anything to elevate your BBQ game, we've got you covered. Here are a few things you can try:",
  },
];

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div>
      <ErrorBody body={body} />
    </div>
  );
}
